<template>
    <button type="button" aria-label="Whatsapp" aria-labelledby="Whatsapp"
        class="bg-transparent focus:outline-none bottom-0" >
        <a :href="formattedWhatsappLink" :class="class" @click.prevent="handleWhatsAppClick" rel="noopener noreferrer" target="_blank"
            title="Find them on Whatsapp" class="bg-[#33CC33] font-bold hover:brightness-105 ease-linear transition-[filter] duration-150 text-[0.716rem] sm:text-[0.813rem] md:text-[0.855rem] whitespace-nowrap flex flex-nowrap gap-2 items-center rounded-[1.25rem] px-4 lg:px-5 py-1.5 text-white">
            <img :src="whatsappIcon"
                class="object-contain w-[19px] h-[18px]" width="19"
                height="18" alt />
            {{  $t('general.call_reseller_whatsapp') }}
        </a>
        <span class="sr-only">Whatsapp</span>
    </button>
</template>

<script>
import { generateWhatsappLink } from "@/helpers";
import whatsappIcon from "@/assets/icons/whatsapp_2.svg";

export default {
    data() {
        return {
            whatsappIcon
        }
    },
    props: {
        whatsappNumber: {
            type:  [String, Number, null],
            default: "",
            required: true
        },
        message: {
            type:  String,
            default: "",
            required: true
        },
        class: {
            type: String,
            default: ""
        },
        preventClick: {
            type: Boolean,
            default: false,
            required: false
        },
        customClick: {
            type: Function,
            default: () => {},
            required: false
        }
    },
    computed:{
        formattedWhatsappLink() {
            return generateWhatsappLink({ phone_number: this.whatsappNumber, message: this.message, link: window?.location?.href || "" });
        },
    },
    methods: {
        handleWhatsAppClick(event){
            if(this.preventClick && this.customClick){
                this.customClick();
            } else {
                this.triggerContactPixelEvent();
                // Allow default link behavior when preventClick is false
                if (!this.preventClick) {
                    window.open(this.formattedWhatsappLink, '_blank');
                }
            }
        },
        triggerContactPixelEvent(){
            fbq('track', 'Contact');
        }
    },
}
</script>

<style></style>